




























































































































































































































































































import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'
import { DatePeriodEnum, SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import ProgressCircular from '@/components/ProgressCircular.vue'
import moment from 'moment'
import CockpitTreeFilterDialog from '@/components/cockpit/CockpitTreeFilterDialog.vue'
import PeriodSelector from '@/components/PeriodSelector.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { DatePeriod } from '@/model/DatePeriod'
import {
  DxColumn, DxColumnChooser,
  DxDataGrid,
  DxFilterRow, DxGrouping,
  DxGroupPanel,
  DxScrolling,
  DxSelection,
  DxSorting, DxStateStoring
} from 'devextreme-vue/data-grid'
import deMessages from "devextreme/localization/messages/de.json"
import frMessages from "devextreme/localization/messages/fr.json"
import itMessages from "devextreme/localization/messages/it.json"
import { locale, loadMessages } from "devextreme/localization"
import {
  COMPANY_GET_BASIC_COMPANY_STRUCTURE,
  COMPANY_GET_COMPANY_STRUCTURE_HOLIDAY_LIST,
  GET_SELECTED_UI_LANGUAGE
} from '@/store/getter-types'
import { BryntumScheduler } from '@bryntum/scheduler-vue';
import { TimeRange } from '@/types'
import _ from 'lodash'
import { Holiday } from '@/model/companyStructure/Holiday'
import CockpitDetailDialog from '@/components/cockpit/CockpitDetailDialog.vue'
import Kanban from '@/components/cockpit/Kanban.vue'
import {
  COMPANY_FETCH_COMPANY_STRUCTURE, FETCH_ADDRESS_EMPLOYEE_LIST,
  FETCH_COCKPIT_DATA,
  FETCH_COCKPIT_STRUCTURE,
  FETCH_NOTES_TYPE_LIST
} from '@/store/action-types'
import { GetSachbearbeiterResponse, LeitstandStructurResponse } from '@/types/service-response'
import { FetchCockpitPayload } from '@/types/payload'
import { generateUuid } from '@/services/uuid-service'
import NotesDialog from '@/components/master-data/address/NotesDialog.vue'
import { NoteType } from '@/model/addresses/NoteType'
import { Employee } from '@/model/companyStructure/Employee'
import { Note } from '@/model/addresses/Note'
import { SearchAddressEmployee } from '@/model/addresses/SearchAddressEmployee'
import ProjectWindow from '@/components/project/ProjectWindow.vue'
import { Replacement } from '@/model/disposition/Replacement'
import DispositionRepresentativeDialog from '@/components/disposition/DispositionRepresentativeDialog.vue'
import i18n from '@/i18n'
import * as securityService from '@/services/security-service'

interface ComponentData {
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  tableHeight: string

  dateRules: Function[]
  dateFromFormatted: string
  dateFrom: string
  menuFrom: boolean
  dateToFormatted: string
  dateTo: string
  menuTo: boolean
  selectedDateFrom: string
  selectedDateTo: string

  showNotesDialog: boolean
  notesData: Note | null
  addressId: number | null
  adressLinie: string
  searchAddressEmployee: SearchAddressEmployee[]
  employeeList: Employee[]
  noteTypeList: NoteType[]

  showProjectDialog: boolean,
  projectIdList: number[] | null

  showDispositionRepresentativeDialog: boolean
  dispoReplacementData: Replacement | null

  showTreeFilter: boolean
  treeFilterData: any[]
  selectedTreeFilterItem: any | null
  komprimiert: boolean
  art: number | null
  status: number | null
  prozessart: number | null
  schritt: number | null
  notizart: number | null
  arbeit: number | null
  projekt: number | null
  aufruf: number | null
  period: DatePeriodEnum
  yearPeriodScrollDate: Date
  activeTab: number
  leitstandData: any[]
  selectedRowData: any | null
  showDetailDialog: boolean

  // scheduler
  schedulerPreset: Object
  schedulerColumns: Object[]
  schedulerResources: any[]
  schedulerEvents: any[]
  schedulerStartDate: Date
  schedulerEndDate: Date
  timeRanges: Array<TimeRange>
  timeRangesFeature: any
  groupFeature: string
  sortFeature: string

  currentPeriod: DatePeriod
  holidayList: Array<TimeRange>

  arbeitenList: any[]
  mitarbeiterconfigList: any[]
  notizartenList: any[]
  organizationsList: any[]
  prozessartenList: any[]
  schritteList: any[]
  herkunftList: any[]
  statusList: any[]

  presetList: any
  selectedTask: any | null
  isKanbanCreate: boolean
  isKanbanDelete: boolean
}

export default Vue.extend({
  name: 'CockpitPage',

  components: {
    ProgressCircular,
    CockpitDetailDialog,
    CockpitTreeFilterDialog,
    PeriodSelector,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxSelection,
    DxStateStoring,
    BryntumScheduler,
    Kanban,
    NotesDialog,
    ProjectWindow,
    DispositionRepresentativeDialog
  },

  data (): ComponentData {
    const currentPeriod: DatePeriod = DatePeriod.createFromNow(DatePeriodEnum.Month)

    return {
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      tableHeight: '',

      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true
        },

        (value: string) => {
          return value.length !== 10 ? this.$t('errors.wrongDate').toString() : true
        }
      ],

      dateFromFormatted: '',
      dateFrom: '',
      menuFrom: false,
      dateToFormatted: '',
      dateTo: '',
      menuTo: false,
      selectedDateFrom: '',
      selectedDateTo: '',

      showNotesDialog: false,
      notesData: null,
      addressId: null,
      adressLinie: '',
      searchAddressEmployee: [],
      employeeList: [],
      noteTypeList: [],

      showProjectDialog: false,
      projectIdList: null,

      showDispositionRepresentativeDialog: false,
      dispoReplacementData: null,

      showTreeFilter: false,
      treeFilterData: [],
      selectedTreeFilterItem: null,
      komprimiert: false,
      art: null,
      status: 5,
      prozessart: null,
      schritt: null,
      notizart: null,
      arbeit: null,
      projekt: null,
      aufruf: null,
      period: DatePeriodEnum.Month,
      yearPeriodScrollDate: moment().toDate(),
      activeTab: 0,
      leitstandData: [],
      selectedRowData: null,
      showDetailDialog: false,

      // scheduler
      schedulerPreset: DatePeriodEnum.Month,
      schedulerColumns: [
        {
          text: '',
          width: 300,
          field: 'groupName',
          hidden: true,
        },
        {
          text: this.$t('cockpitPage.schedulerLabel1').toString(),
          width: 50,
          field: 'position',
          hidden: true
        },
        {
          text: this.$t('cockpitPage.schedulerLabel2').toString(),
          width: 300,
          field: 'name',
          hidden: false,
          editor: false
        },
        {
          text: this.$t('cockpitPage.schedulerLabel3').toString(),
          width: 50,
          field: 'wer',
          hidden: false,
          editor: false
        },
        {
          text: this.$t('cockpitPage.schedulerLabel4').toString(),
          width: 200,
          field: 'dateRange',
          hidden: false,
          editor: false,
          sortable: {
            sortFn: function(a: any, b: any) {
              const startDateA = moment(a.dateRange.split('-')[0], 'DD.MM.YYYY');
              const startDateB = moment(b.dateRange.split('-')[0], 'DD.MM.YYYY');

              return startDateA.isBefore(startDateB) ? -1 : 1
            }
          },
        }
      ],
      schedulerResources: [],
      schedulerEvents: [],
      schedulerStartDate: currentPeriod.startDate,
      schedulerEndDate: currentPeriod.endDate,
      timeRanges: [],
      timeRangesFeature: {
        showCurrentTimeLine : false,
        showHeaderElements  : false,
        enableResizing      : false
      },
      groupFeature: 'groupName',
      sortFeature: 'id',

      currentPeriod: currentPeriod,
      holidayList: [],

      arbeitenList: [],
      mitarbeiterconfigList: [],
      notizartenList: [],
      organizationsList: [],
      prozessartenList: [],
      schritteList: [],
      herkunftList: [],
      statusList: [],

      presetList: [
        {
          id: 'year',
          tickWidth: 50,
          //displayDateFormat: 'HH:mm',
          shiftIncrement: 1,
          shiftUnit: 'month',
          //defaultSpan: 24,

          timeResolution: {
            unit: 'minute',
            increment: 15
          },

          headers: [
            {
              unit: 'week',
              dateFormat: 'W',
              align: 'center',
              renderer: function (start: string | Date) {
                return i18n.t('calendarWeek').toString() + ' '  + moment(start).locale('de').format('W');
              }
            },
            {
              unit: 'month',
              dateFormat: 'MMMM',
              align: 'center',
              renderer: function (start: string | Date) {
                return moment(start).locale('de').format('MMMM') +" "+ moment(start).locale('de').format('YYYY');
              }
            },
            {
              unit: 'day',
              dateFormat: 'dd',
              align: 'center',
              renderer: function(start: string | Date){
                return moment(start).locale('de').format('DD') +' '+ moment(start).locale('de').format('dd');
              }
            }
          ],
          columnLinesFor: 2

        },
        {
          id: 'month',
          tickWidth: 35,
          //displayDateFormat: 'HH:mm',
          shiftIncrement: 1,
          shiftUnit: 'month',
          //defaultSpan: 24,

          timeResolution: {
            unit: 'minute',
            increment: 15
          },

          headers: [
            {
              unit: 'week',
              dateFormat: 'W',
              align: 'center',
              renderer: function (start: string | Date) {
                return i18n.t('calendarWeek').toString() + ' ' + moment(start).locale('de').format('W');
              }
            },
            {
              unit: 'day',
              dateFormat: 'DD',
              align: 'center',
            },
            {
              unit: 'day',
              dateFormat: 'dd',
              align: 'center',
              renderer: function(start: string | Date){
                return moment(start).locale('de').format('dd');
              }
            }
          ],
          columnLinesFor: 2

        },
        {
          id: 'week',
          tickWidth: 60,
          //displayDateFormat: 'HH:mm',
          shiftIncrement: 1,
          shiftUnit: 'week',
          //defaultSpan: 24,

          timeResolution: {
            unit: 'minute',
            increment: 15
          },

          headers: [
            {
              unit: 'day',
              dateFormat: 'DD',
              align: 'center'
            },
            {
              unit: 'day',
              dateFormat: 'dd',
              align: 'center',
              renderer: function(start: string | Date){
                return moment(start).locale('de').format('dd');
              }
            }
          ],
          columnLinesFor: 1
        },
        {
          id: 'day',
          tickWidth: 44,

          displayDateFormat: 'HH:mm',

          shiftIncrement: 1,
          shiftUnit: 'day',
          defaultSpan: 12,

          timeResolution: {
            unit: 'minute',
            increment: 15
          },

          headers: [
            {
              unit: 'day',
              dateFormat: 'dddd DD MMM YYYY',
              align: 'center',
              renderer: function(start: string | Date, end: string | Date, headerConfig: any, index: any){
                return moment(start).locale('de').format('dddd DD MMM YYYY');
              }
            },
            {
              unit: 'hour',
              dateFormat : this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.xsOnly ? 'HH' : 'HH:mm',
              align: 'center',
            }
          ],

          columnLinesFor: 1
        }
      ],
      selectedTask: null,
      isKanbanCreate: false,
      isKanbanDelete: false
    }
  },

  watch: {
    activeTab (newVal: number): void {
      if(newVal === 0) {
        //@ts-ignore
        setTimeout(() => { this.$refs.dataGrid.instance.refresh() }, 0)
        setTimeout(() => { this.onResize() }, 0)
      }
    },

    dateFromFormatted (newVal: string): void {
      if(newVal) {
        this.dateFrom = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
        const form: any = this.$refs['form1']
        if(newVal.length === 10 && form.validate()) {
          this.onFromValueChange(newVal)
        }
      }
    },

    dateToFormatted (newVal: string): void {
      if(newVal) {
        this.dateTo = moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD')
        const form: any = this.$refs['form2']
        if(newVal.length === 10 && form.validate()) {
          this.onToValueChange(newVal)
        }
      }
    },

    currentPeriod (newVal: DatePeriod): void {
      /*let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      data.currentPeriod = newVal
      this.$router.push({name: 'absences', query: { data: JSON.stringify(data) }})*/

      // @ts-ignore
      const engine = this.$refs.scheduler.instance
      if (this.period !== newVal.period) {
        if(newVal.period === DatePeriodEnum.WorkingWeek) {
          engine.setViewPreset(DatePeriodEnum.Week)
          this.period = newVal.period
        } else {
          engine.setViewPreset(newVal.period)
          this.period = newVal.period
        }
      }

      engine.setStartDate(newVal.startDate)
      engine.setEndDate(newVal.endDate)

      if(newVal.period === DatePeriodEnum.Year) {
        setTimeout(() => {
          engine.scrollToDate(moment(this.yearPeriodScrollDate),
              {
                block: 'start'
              }
          )
        }, 0)
      }
      this.setTimeRanges(newVal.startDate, newVal.endDate)
      //TODO UPDATE DATA SET
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    selectedLanguageCode (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    schedulerAutoHeight (): boolean {
      if (this.$vuetify.breakpoint.smOnly || this.$vuetify.breakpoint.xsOnly) {
        return false
      } else {
        return false
      }
    },

    showKanban (): boolean {
      return securityService.isVisible(SecurityArea.Cockpit, SecurityComponent.Kanban)
    },

    disableKanban (): boolean {
      return securityService.isDisabled(SecurityArea.Cockpit, SecurityComponent.Kanban)
    }
  },

  methods: {
    selectTask (item: any | null): void {
      this.selectedTask = item
    },

    stopCreate (): void {
      this.isKanbanCreate = false
    },

    stopDelete (): void {
      this.isKanbanDelete = false
    },

    onDateFromChange (date: string): void {
      this.dateFromFormatted = moment(date).format('DD.MM.YYYY')
      this.onFromValueChange(this.dateFromFormatted)
    },

    onFromValueChange (value: string): void {
      this.selectedDateFrom = value
    },

    onFromFocus (): void {
      setTimeout(() => {
        if(!this.menuFrom) {
          this.menuFrom = true
        }
      }, 100)
    },

    onFromBlur (): void {
      setTimeout(() => {
        if(this.menuFrom) {
          this.menuFrom = false
        }
      }, 100)
    },

    onDateToChange (date: string): void {
      this.dateToFormatted = moment(date).format('DD.MM.YYYY')
      this.onToValueChange(this.dateToFormatted)
    },

    onToValueChange (value: string): void {
      this.selectedDateTo = value
    },

    onToFocus (): void {
      setTimeout(() => {
        if(!this.menuTo) {
          this.menuTo = true
        }
      }, 100)
    },

    onToBlur (): void {
      setTimeout(() => {
        if(this.menuTo) {
          this.menuTo = false
        }
      }, 100)
    },



    onPeriodSelected (period: DatePeriod): void {
      this.currentPeriod = period
    },

    yearPeriodChangeDate (value: string) {
      //console.log(value)
    },

    onRefreshClick (): void {
      this.fetchCockpitData()
    },

    onAddTaskClick (): void {
      this.isKanbanCreate = true
    },

    onEditTaskClick (): void {
      //console.log('FILTER')
    },

    onDeleteTaskClick (): void {
      this.isKanbanDelete = true
    },

    onToolbarFilterClick (): void {
      //console.log('FILTER')
    },

    isTextButton (item: string): boolean {
      return this.period === item
    },

    periodButtonColor (item: string): string {
      return this.period === item  ? 'primary' : 'secondary'
    },

    onTreeFilterClear (): void {
      this.selectedTreeFilterItem = null
    },

    onTreeFilterClick (): void {
      this.showTreeFilter = true
    },

    onTreeFilterSave (item: any): void {
      this.selectedTreeFilterItem = item
      this.showTreeFilter = false
    },

    onTreeFilterClose (): void {
      this.showTreeFilter = false
    },

    onYearPeriodClick (): void {
      this.period = DatePeriodEnum.Year
    },

    onMonthPeriodClick (): void {
      this.period = DatePeriodEnum.Month
    },

    onWeekPeriodClick (): void {
      this.period = DatePeriodEnum.Week
    },

    onWorkingWeekPeriodClick (): void {
      this.period = DatePeriodEnum.WorkingWeek
    },

    onDayPeriodClick (): void {
      this.period = DatePeriodEnum.Day
    },

    onSelectionChanged(event: any): void {
      this.selectedRowData = event.selectedRowsData[0]
    },

    addMenuItems (e: any): void {
      if (e.target == 'content') {
        //@ts-ignore
        this.$refs.dataGrid.instance.selectRows([e.row.key])

        if (!e.items) e.items = []

        e.items.push({
          text: 'Details',
          onItemClick: () => {
            this.showDetailDialog = true
          }
        });
      }
    },

    onDetailDialogClose (): void {
      this.showDetailDialog = false
    },

    eventRenderer ({ eventRecord, tplData }: any): any {
      let c = `<div  class="cockpit-event">${eventRecord.data.name}</div>`
      return `<div class="event-template ${eventRecord.data.name}">
                ${c}
              </div>`
    },

    onSchedulerCellDblClick (e: any): void {
      if(e.column.data.field === 'name') {
        const foundData: any | undefined = this.leitstandData.find((item: any) => item.ID === e.record.data.id)
        this.openDetail(foundData)
      }
    },

    setTimeRanges (startDate: Date, endDate: Date): void {
      let start = moment(startDate)
      let end = moment(endDate)
      let day = 0

      let result = this.holidayList
      let current = start.clone()

      while (current.day(7 + day).isBefore(end)) {
        const sun = current.clone().format('YYYY-MM-DD')
        const sat = moment(current.clone()).subtract(1, 'd').format('YYYY-MM-DD')

        const foundSun: TimeRange | undefined = _.find(this.holidayList, { startDate: sun })
        const foundSat: TimeRange | undefined = _.find(this.holidayList, { startDate: sat })

        if(!foundSun) {
          result.push({ startDate: sun, duration: 1, durationUnit: 'day' })
        }
        if(!foundSat) {
          result.push({ startDate: sat, duration: 1, durationUnit: 'day' })
        }
      }

      this.timeRanges = result
    },

    onResize (): void {
      if(this.$refs.toolbar && this.$refs.filter && this.$refs.tabs && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.toolbar as HTMLElement).clientHeight + (this.$refs.filter as HTMLElement).clientHeight + (this.$refs.tabs as HTMLElement).clientHeight + 12
          this.tableHeight = `height: calc(${vh}px - ${this.$vuetify.breakpoint.mdAndUp ? '64px' : '56px'} - ${height}px)`
        } else {
          this.tableHeight = 'height: 500px'
        }
      } else {
        this.tableHeight = 'height: 500px'
      }
    },

    setTreeFilterData (): void {
      this.organizationsList.filter((item: any) => item.Order === 1).forEach((item: any) => {
        let typeP: any = {
          id: item.BasisID,
          oid: item.OID,
          name: item.Bezeichnung,
          type:'P',
          children: []
        }
        this.organizationsList.filter((i: any) => i.Order === 2 && i.Parent === typeP.id).forEach((i: any) => {
          let typeA: any = {
            id: i.BasisID,
            oid: i.OID,
            name: i.Bezeichnung,
            type:'A',
            children: []
          }

          this.organizationsList.filter((m: any) => m.Order === 3 && m.Parent === typeA.id).forEach((m: any) => {
            const typeM: any = {
              id: m.BasisID,
              oid: m.OID,
              name: m.Bezeichnung,
              type:'M',
            }

            typeA.children.push(typeM)
          })

          typeP.children.push(typeA)
        })

        this.treeFilterData.push(typeP)
      })
    },

    async fetchCockpitData (): Promise<void> {
      const payload: FetchCockpitPayload = {
        profitcenter: this.selectedTreeFilterItem && this.selectedTreeFilterItem.type === 'P' ? this.selectedTreeFilterItem.oid.toString() : '0',
        abteilung: this.selectedTreeFilterItem && this.selectedTreeFilterItem.type === 'A' ? this.selectedTreeFilterItem.oid.toString() : '0',
        mitarbeiter: this.selectedTreeFilterItem && this.selectedTreeFilterItem.type === 'M' ? this.selectedTreeFilterItem.oid.toString() : '0',
        sprache: this.selectedLanguageId.toString(),
        prozessart: this.prozessart ? this.prozessart.toString() : '0',
        schritt: this.schritt ? this.schritt.toString() : '0',
        arbeit: this.arbeit ? this.arbeit.toString() : '0',
        notizart: this.notizart ? this.notizart.toString() : '0',
        datumVon: this.currentPeriod ? moment(this.currentPeriod.startDate).format('YYYY-MM-DD') : '0',
        datumBis: this.currentPeriod ? moment(this.currentPeriod.endDate).format('YYYY-MM-DD') : '0',
        art: this.art ? this.art.toString() : '0',
        status: this.status ? this.status.toString() : '0',
        komprimiert: this.komprimiert ? '1' : '0',
        projekt: this.projekt ? this.projekt.toString() : '0',
        aufruf: this.aufruf ? this.aufruf.toString() : '0',
      }

      try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_COCKPIT_DATA, payload)
        this.loading = false
        if(response) {
          this.leitstandData = response
          this.schedulerEvents = []
          this.schedulerResources = this.leitstandData.map((item: any, index: number) => {

            const days: number = moment(item.Ende, 'DD.MM.YYYY HH:mm:ss').diff(moment(item.Beginn, 'DD.MM.YYYY HH:mm:ss'), 'days') + 1
            for (let i = 0; i < days; i++) {
              this.schedulerEvents.push(
                  {
                    id: generateUuid(),
                    resourceId: item.ID,
                    name: '',
                    eventColor: moment(item.Beginn, 'DD.MM.YYYY HH:mm:ss').add(i, 'days').endOf('day').isBefore(moment(), 'day') ? '#FF0000' : moment(item.Beginn, 'DD.MM.YYYY HH:mm:ss').add(i, 'days').endOf('day').isSame(moment(), 'day') ? '#FFEA00' : "#339933",
                    resizable: false,
                    draggable: false,
                    startDate: moment(item.Beginn, 'DD.MM.YYYY HH:mm:ss').add(i, 'days').startOf('day').toISOString(),
                    endDate: moment(item.Beginn, 'DD.MM.YYYY HH:mm:ss').add(i, 'days').endOf('day').toISOString()
                  },
              )
            }

            const foundArt: any | undefined = this.herkunftList.find((i: any) => i.Wert === item.Art)
            return {
              id: item.ID,
              groupId: item.Art,
              groupName: foundArt ? foundArt.Bezeichnung : '',
              position: foundArt ? foundArt.Position : 0,
              name: item.Anzeige,
              wer: item.Verantwortlich,
              dateRange: `${moment(item.Beginn, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY')}-${moment(item.Ende, 'DD.MM.YYYY HH:mm:ss').format('DD.MM.YYYY')}`
            }
          })
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchCockpitStructure (): Promise<void> {
      try {
        const response: LeitstandStructurResponse = await this.$store.dispatch(FETCH_COCKPIT_STRUCTURE)
        if(response) {
          this.arbeitenList = response.arbeiten
          this.mitarbeiterconfigList = response.mitarbeiterconfig
          this.notizartenList = response.notizarten
          this.organizationsList = response.organizations
          this.prozessartenList = response.prozessarten
          this.schritteList = response.schritte
          this.herkunftList = response.herkunft
          this.statusList = response.status

          this.setTreeFilterData()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    rowDblClick(event: any): void {
      this.openDetail(event.data)
    },

    async openDetail(data: any): Promise<void> {
      if(data.Notiz && data.Adresse && data.Art === 1) {
        await this.fetchAddressEmployee(data.Adresse)
        await this.fetchEmployeeList()
        await this.fetchNoteTypeList()

        this.notesData = new Note(
            data.Notiz,
            data.Sachbearbeiter ? data.Sachbearbeiter : '',
            data.NotizSachbearbeiterID ? data.NotizSachbearbeiterID : undefined,
            data.Mitarbeiter ? data.Mitarbeiter : undefined,
            data.Beginn ? data.Beginn : '',
            data.Ende ? data.Ende : '',
            data.AnteilErledigt ? data.AnteilErledigt : 0,
            data.NotizAutor ? data.NotizAutor : undefined,
            data.NotizPrivat !== null ? data.NotizPrivat !== 0 : false,
            data.Notizart ? data.Notizart : undefined,
            data.Titel ? data.Titel : '',
            data.Beschreibung ? data.Beschreibung : '',
            data.NotizAdressVerantwortlich ? data.NotizAdressVerantwortlich : undefined,
            data.NotizQualitaet ? data.NotizQualitaet : null
        )

        this.addressId = data.Adresse
        this.adressLinie = data.AdressLinie
        this.showNotesDialog = true
      } else if(data.Projekt && data.Art === 2) {
        this.projectIdList = [data.Projekt]
        this.showProjectDialog = true
      } else if(data.Nummer && data.Adresse && data.Absenz && data.Art === 3) {
        const dispoReplacementList: Replacement[] = Replacement.createFromResponse([
          {
            FullName: null,
            Kurzzeichen: null,
            M_ID: 0,
            PersonalNummer: null,
            AdressLinie: data.AdressLinie,
            AdressNummer: data.Nummer,
            AdressID: data.Adresse,
            DatumBis: '',
            DatumVon: '',
            Grund: 0,
            STV_Vorgabe: null,
            M_Email: null,
            M_Phone: null,
            AbwesenheitenID: data.Absenz
          }])

        this.dispoReplacementData = dispoReplacementList && dispoReplacementList[0] ? dispoReplacementList[0]: null
        if(this.dispoReplacementData) {
          this.showDispositionRepresentativeDialog = true
        }
      }
    },

    savedNotesDialog (): void {
      this.onRefreshClick()
      this.showNotesDialog = false
      this.notesData = null
      this.addressId = null
      this.adressLinie = ''
    },

    closeNotesDialog (): void {
      this.showNotesDialog = false
      this.notesData = null
      this.addressId = null
      this.adressLinie = ''
    },

    async fetchAddressEmployee(addressId: number): Promise<void> {
      try {
        this.loading = true
        const response: GetSachbearbeiterResponse = await this.$store.dispatch(FETCH_ADDRESS_EMPLOYEE_LIST, addressId)
        if(!response.IsError && response.Data) {
          this.searchAddressEmployee = SearchAddressEmployee.createFromResponse(response.Data)
        }
      } catch {
      } finally {
        this.loading = false
      }
    },

    async fetchEmployeeList (): Promise<void> {
      if((this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList.length === 0) {
        await this.$store.dispatch(COMPANY_FETCH_COMPANY_STRUCTURE)
        this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList
      }
      this.employeeList = (this.$store.getters[COMPANY_GET_BASIC_COMPANY_STRUCTURE]).employeeList
    },

    async fetchNoteTypeList (): Promise<void> {
      if(this.noteTypeList.length === 0) {
        this.noteTypeList = await this.$store.dispatch(FETCH_NOTES_TYPE_LIST)
      }
    },

    savedProjectDialog (projectId: number): void {
      this.projectIdList =  [projectId]
    },

    closeProjectDialog (): void {
      this.onRefreshClick()
      this.showProjectDialog = false
      this.projectIdList = null
    },

    closeDispositionRepresentativeDialog (): void {
      this.onRefreshClick()
      this.showDispositionRepresentativeDialog = false
      this.dispoReplacementData = null
    },
  },

  created (): void {
    loadMessages(deMessages)
    loadMessages(frMessages)
    loadMessages(itMessages)
    locale(this.selectedLanguageCode)
  },

  async mounted(): Promise<void> {
    await this.fetchCockpitStructure()
    await this.fetchCockpitData()

    const holidays: Array<Holiday> = this.$store.getters[COMPANY_GET_COMPANY_STRUCTURE_HOLIDAY_LIST]
    holidays.forEach((item: Holiday) => {
      const date: string = moment(item.date, 'DD.MM.YYYY').format('YYYY-MM-DD')
      this.holidayList.push({ startDate : date, duration : 1, durationUnit : 'day' })
    })
    this.setTimeRanges(this.currentPeriod.startDate, this.currentPeriod.endDate)

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
